module.exports = __webpack_public_path__ + "img/service-icon1.35e7b67d.png";